exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, " .buttonContainer__BulkActionsCard-module___gt7lA {\n    display: flex;\n    gap: 8px;\n    margin-top: 16px;\n  }\n\n  .modal__BulkActionsCard-module___34jFc {\n    background-color: #0000001d;\n  }\n\n  @media (max-width: 475px) {\n    .buttonContainer__BulkActionsCard-module___gt7lA {\n      flex-direction: column;\n    }\n  }\n", ""]);

// Exports
exports.locals = {
	"buttonContainer": "buttonContainer__BulkActionsCard-module___gt7lA",
	"modal": "modal__BulkActionsCard-module___34jFc"
};